import type { RouteRecordRaw } from 'vue-router';

/**
 * Printing & labels admin screens (WP7.7, ADR-084). Permission-gated inside each page (which renders
 * `ForbiddenState` when missing), mirroring `admin-system.ts` — `printing` is a business module
 * (`@RequireModule('printing')` on the API side), so the nav entry is additionally gated on
 * `session.hasModule('printing')` in `AppShell.vue`.
 */
export const printingRoutes: RouteRecordRaw[] = [
  {
    path: 'admin/printing/templates',
    name: 'admin-print-templates',
    component: () => import('../pages/admin/printing/PrintTemplatesPage.vue'),
    meta: { requiresModule: 'printing' },
  },
  {
    path: 'admin/printing/templates/:key/versions',
    name: 'admin-print-template-versions',
    component: () => import('../pages/admin/printing/PrintTemplateVersionsPage.vue'),
    // `key` is a reserved Vue prop name (vue/no-reserved-props) -- map the route param to
    // `templateKey` instead of using bare `props: true`.
    props: (route) => ({ templateKey: route.params['key'] }),
    meta: { requiresModule: 'printing' },
  },
];
